import React, {
  useState,
  useEffect
} from 'react';
import Input from './Input';

import './style.css';

const PERIOD = '.';

const PriceFilter = (props) => {

  const { clearState } = props;

  const [input, setInput] = useState('');

  useEffect(() => {
    clearState ? setInput('') : null
  }, []);


  const validate = (element) => {
    const { value } = element.target;

    // eslint-disable-next-line no-param-reassign
    element.target.value = (value.indexOf(PERIOD) >= 0)
      ? (value.substr(0, value.indexOf(PERIOD)) + value.substr(value.indexOf(PERIOD), 3))
      : value;
  };

  const getInputValue = () => {
    if (clearState) return '';

    if (input) {
      return input;
    } else {
      return urlFilter
    }
  };

  const handleKeyDown = (e) => {
    const { convertToUrl } = props;

    if (e.key === 'Enter') {
      convertToUrl()
    }
  };

  const {
    autoFocus,
    id,
    text,
    selectFilter,
    inputFilterType,
    urlFilter,
    borderColor,
  } = props;

  return (
    <div>
      <div style={{ display: 'flex', marginTop: 4 }}>
        <div style={{ width: '100%', position: 'relative' }}>
          <div style={{ position: 'absolute', left: 14, top: '50%', marginTop: '-8px' }}>
            $
          </div>
        <Input
          id={id}
          type="number"
          pattern="\d*"
          inputMode="numeric"
          placeholder={text}
          step='.01'
          autoFocus={autoFocus}
          className='price-filter-input'
          onInput={(e) => {
            setInput(validate(e));
            selectFilter(inputFilterType, [e.target.value])
          }}
          spellCheck={false}
          value={getInputValue()}
          onKeyDown={handleKeyDown}
        borderColor={borderColor}
        />
        </div>
      </div>
    </div>
  );
};

export default PriceFilter;



// WEBPACK FOOTER //
// ./src/components/AdvancedFilter/PriceFilter.jsx